module.exports = __webpack_public_path__ + "static/media/login-bg.15296c67.jpg";